import React from "react";

export default function RoundedStripe() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 64 65"
    >
      <path
        fill="#000"
        d="M8.577 2.532a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM8.577 13.252a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM3.217 40.051a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM30.016 2.532a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM30.016 34.691a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM40.737 2.532a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0Z"
      />
      <rect width={3.275} height={19.34} y={6.253} fill="#000" rx={1.637} />
      <path
        fill="#000"
        d="M63.898 40.051a1.608 1.608 0 1 0-3.215 0 1.608 1.608 0 0 0 3.215 0Z"
      />
      <rect
        width={3.275}
        height={19.34}
        x={60.681}
        y={6.253}
        fill="#000"
        rx={1.637}
      />
      <rect
        width={3.233}
        height={13.578}
        x={10.701}
        y={11.935}
        fill="#000"
        rx={1.616}
      />
      <rect
        width={3.222}
        height={8.593}
        x={16.072}
        y={6.253}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={8.593}
        x={21.443}
        y={16.988}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={8.593}
        x={37.516}
        y={11.617}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={8.593}
        x={37.516}
        y={27.742}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.275}
        height={8.493}
        x={5.321}
        y={27.845}
        fill="#000"
        rx={1.637}
      />
      <path
        fill="#000"
        d="M47.047 2.532a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM43.831 63.316a1.608 1.608 0 1 1 3.216 0 1.608 1.608 0 0 1-3.216 0ZM22.392 63.316a1.608 1.608 0 1 1 3.216 0 1.608 1.608 0 0 1-3.216 0ZM11.671 63.316a1.608 1.608 0 1 1 3.216 0 1.608 1.608 0 0 1-3.216 0ZM5.361 63.316a1.608 1.608 0 1 1 3.216 0 1.608 1.608 0 0 1-3.216 0ZM8.577 45.817a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM30.016 45.817a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM40.77 45.818a1.608 1.608 0 1 0-3.215 0 1.608 1.608 0 0 0 3.216 0ZM47.047 45.817a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM47.047 13.252a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0Z"
      />
      <rect
        width={3.222}
        height={8.593}
        x={43.86}
        y={27.742}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={13.924}
        x={16.072}
        y={22.358}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.233}
        height={13.578}
        x={49.587}
        y={11.935}
        fill="#000"
        rx={1.616}
      />
      <rect
        width={3.222}
        height={8.593}
        x={54.957}
        y={6.253}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={13.924}
        x={54.957}
        y={22.358}
        fill="#000"
        rx={1.611}
      />
      <rect
        width={3.222}
        height={19.852}
        x={16.112}
        y={41.653}
        fill="#000"
        rx={1.611}
        transform="rotate(-90 16.112 41.653)"
      />
      <path
        fill="#000"
        d="M3.217 51.307a1.608 1.608 0 1 0-3.216 0 1.608 1.608 0 0 0 3.216 0ZM63.898 51.307a1.608 1.608 0 1 0-3.215 0 1.608 1.608 0 0 0 3.215 0Z"
      />
      <rect
        width={3.222}
        height={19.852}
        x={37.555}
        y={52.909}
        fill="#000"
        rx={1.611}
        transform="rotate(-90 37.555 52.91)"
      />
      <rect
        width={3.222}
        height={13.924}
        x={26.813}
        y={9.469}
        fill="#000"
        rx={1.611}
        transform="rotate(-90 26.813 9.469)"
      />
      <rect
        width={3.275}
        height={14.428}
        fill="#000"
        rx={1.637}
        transform="matrix(1 0 0 -1 16.066 58.646)"
      />
      <rect
        width={3.222}
        height={13.924}
        fill="#000"
        rx={1.611}
        transform="matrix(0 1 1 0 26.813 55.42)"
      />
      <rect
        width={3.222}
        height={13.924}
        x={32.144}
        y={16.988}
        fill="#000"
        rx={1.611}
      />
    </svg>
  );
}
